import { render, staticRenderFns } from "./process.page.vue?vue&type=template&id=c4bad250"
import script from "./process.page.vue?vue&type=script&lang=ts"
export * from "./process.page.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports